export function useSecurity() {
    function isPasswordSecure(password) {
        const passwordPattern = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
        return passwordPattern.test(password);
    }

    return {isPasswordSecure};
}
